function isAdmin(user) {
    const { signInUserSession: { accessToken: { payload } } } = user;
    if (payload) {
        const groups = payload['cognito:groups'];
        if (groups && groups.length > 0) {
            return groups.includes('admin');
        }
    }
    return false;
}

export default { isAdmin };